import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const TranscriptionIcon = createIcon({
  displayName: 'TranscriptionIcon',
  path: [
    <rect
      x='4.5'
      y='7'
      width='15'
      height='1.5'
      rx='0.75'
      fill='currentColor'
    />,
    <rect
      x='4.5'
      y='11.5'
      width='15'
      height='1.5'
      rx='0.75'
      fill='currentColor'
    />,
    <rect
      x='4.5'
      y='16.5'
      width='10'
      height='1.5'
      rx='0.75'
      fill='currentColor'
    />
  ],
  defaultProps: defaultProps
})
